import React, { useRef} from"react"
import { Line } from 'react-chartjs-2';
import ImgDownload from "../../images/Image_download.png";
import ExcelImg from "../../images/excel.png";
import * as XLSX from 'xlsx'


import {Chart as ChartJS, BarElement,CategoryScale,LinearScale,Tooltip,Legend} from "chart.js";


ChartJS.register(
    BarElement,CategoryScale,LinearScale,Tooltip,Legend
)

function LineChart({chartData, chartOptions,year, excelData}){



    const canvasRef = useRef(null);
      
        const handleImgDownload = () => {
          const canvas = canvasRef.current.canvas;
        
          const url = canvas.toDataURL("image/png");
          const a = document.createElement("a");
          a.href = url;
          a.download = "Chart.png";
          a.click();
        }


    const handleDownload = () => {
        console.log(excelData)
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "data.xlsx");
    };

    
    return(
        <div style = {{backgroundColor: "white", height : 500}}>
            <nav className="navbar navbar-expand-sm">
                <ul className ="navbar-nav ml-auto">
                    <li className="nav-item">
                        <button onClick = {handleImgDownload} className="navbar-brand buttons" >
                            <img src= {ImgDownload} width="20" height="20" alt="Download"  border = "0" />
                        </button>
                    </li>
                    <li className="nav-item">
                        <button onClick = {handleDownload}  className="navbar-brand buttons" >
                            <img src= {ExcelImg} width="20" height="20" alt="Download Excel"/>
                        </button>
                    </li>
                </ul>
            </nav>
            <div style = {{height: "80%", width: "100%"}}>
                <Line ref={canvasRef} data = {chartData} options = {chartOptions}></Line>
            </div>
        </div>
        
       
    )
}




export default LineChart;